import React, { useState } from 'react';
import './Achievements.css';

const Achievements = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [lightboxVisible, setLightboxVisible] = useState(false);
    const [currentImage, setCurrentImage] = useState("");
    const [lightboxCaption, setLightboxCaption] = useState("");

    const achievements = [
        {
            img: "../assets/awards/profile.jpg",
            title: "FDP Certificate: Reimagining Higher Education with Indian Knowledge Systems",
            subtitle: "Lloyd Group of Institutions & California State University, San Bernardino — March 2025",
            icon: "📘"
        },
        {
            img: "../assets/awards/profile.jpg",
            title: "Design Inventor: Generative AI Based Customer Feedback Kiosk",
            subtitle: "Registered Feb 28, 2025 | Reg. No. 449822-001 | Patent Office, Govt. of India",
            icon: "🛡️"
        },
        {
            img: "../assets/awards/profile.jpg",
            title: "Patent Published",
            subtitle: "Method for Analyzing Emotions & Sentiments During Coronavirus Pandemic",
            icon: "🧠"
        },
        {
            img: "../assets/awards/profile.jpg",
            title: "ATAL Academy Program: Financial Modelling - A Tool for Decision Making",
            subtitle: "Sri Balaji University, Pune — Nov 25–30, 2024",
            icon: "📊"
        },
        {
            img: "../assets/awards/profile.jpg",
            title: "FDP on Universal Human Values in Technical Education",
            subtitle: "AICTE, GNIET Greater Noida — 01/03/2023 to 03/03/2023",
            icon: "🌱"
        },
        {
            img: "../assets/awards/profile.jpg",
            title: "Book Published: Industrial Economics",
            subtitle: "ISBN 978-81-921345-3-6 — Savera Publisher, 2012",
            icon: "📚"
        }
    ];


    const nextSlide = () => {
        setCurrentSlide((prev) => (prev === achievements.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? achievements.length - 1 : prev - 1));
    };

    const openLightbox = (img, caption) => {
        setCurrentImage(img);
        setLightboxCaption(caption);
        setLightboxVisible(true);
    };

    const closeLightbox = () => {
        setLightboxVisible(false);
    };

    return (
        <div className="awards-section" id="achievements">

            <div className="section-header">
                <h3>Achievements & Recognitions</h3>
            </div>

            <div className="awards-slider-container">
                <button className="slider-arrow slider-arrow-left" onClick={prevSlide}>
                    ‹
                </button>

                <div className="awards-slider">
                    <div
                        className="awards-track"
                        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                    >
                        {achievements.map((item, index) => (
                            <div className="award-slide" key={index}>
                                <div className="award-card">
                                    <div className="award-image">
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                            onError={(e) => {
                                                e.target.style.display = "none";
                                                e.target.nextElementSibling.style.display = "flex";
                                            }}
                                        />
                                        <div className="award-icon-fallback">{item.icon}</div>
                                    </div>

                                    <div className="award-content">
                                        <h4>{item.title}</h4>
                                        <p>{item.subtitle}</p>

                                        <button
                                            className="view-certificate"
                                            onClick={() => openLightbox(item.img, item.title)}
                                        >
                                            View Certificate
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button className="slider-arrow slider-arrow-right" onClick={nextSlide}>
                    ›
                </button>
            </div>

            {/* Dots */}
            <div className="slider-dots">
                {achievements.map((_, i) => (
                    <button
                        key={i}
                        className={`slider-dot ${currentSlide === i ? "active" : ""}`}
                        onClick={() => setCurrentSlide(i)}
                    ></button>
                ))}
            </div>

            {/* Lightbox */}
            {lightboxVisible && (
                <div className="lightbox-overlay" onClick={closeLightbox}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button className="lightbox-close" onClick={closeLightbox}>
                            ×
                        </button>

                        <img src={currentImage} alt="Certificate" />
                        <div className="lightbox-caption">{lightboxCaption}</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Achievements;
